// Cambiar ruta cuando se suba al servidor
export const API_BASE_URL = "https://pcsisgeco.com/api";
export const API_BASE_URL_DOCS = "https://pcsisgeco.com/";
export const API_BASE_DOCS = "https://pcsisgeco.com";

// export const API_BASE_URL = "http://localhost/presencia_backend/api";
// export const API_BASE_URL_DOCS = "http://localhost/presencia_backend/";
// export const API_BASE_DOCS = "http://localhost/presencia_backend";

// Endpoints del backend
export const ENDPOINTS = {
// PUBLICOS
  login: `${API_BASE_URL}/login.php`,
  getOfertas:`${API_BASE_URL}/ofertas/getOfertas.php`,
  getOfertaById: (id) => `${API_BASE_URL}/ofertas/getOfertaById.php?id=${id}`,
  ExternalUser:`${API_BASE_URL}/usuarios/externalUser.php`,
  getarea:`${API_BASE_URL}/usuarios/getarea.php`,
  getprograma:`${API_BASE_URL}/usuarios/getprogramas.php`,
  ForgotPassword:`${API_BASE_URL}/usuarios/forgotPassword.php`,

// PRIVADOS
// AUTH
  me: `${API_BASE_URL}/usuarios/me.php`,
  updateEmail:`${API_BASE_URL}/usuarios/users/updateEmail.php`,
  updatePassword:`${API_BASE_URL}/usuarios/users/updatePassword.php`,
  verify2FA_login:`${API_BASE_URL}/usuarios/users/verify_2fa.php`,
  enable2FA:`${API_BASE_URL}/usuarios/users/activate_mfa.php`,
  disable2FA:`${API_BASE_URL}/usuarios/users/disable_mfa.php`,
// USUARIO
  getUsers:`${API_BASE_URL}/usuarios/users/getUsers.php`,
  createUser:`${API_BASE_URL}/usuarios/users/createUser.php`,
  resetPassword:`${API_BASE_URL}/usuarios/users/resetPassword.php`,
  changeState:`${API_BASE_URL}/usuarios/users/changeState.php`,
  changerole:`${API_BASE_URL}/usuarios/users/changerole.php`,
// OFERTA
  getOffers:`${API_BASE_URL}/usuarios/ofertas/getOffers.php`,
  changeStateOffer:`${API_BASE_URL}/usuarios/ofertas/changeStateOffer.php`,
  updateOfferById: (id) => `${API_BASE_URL}/usuarios/ofertas/updateOfferById.php?id=${id}`,
  createOffer: `${API_BASE_URL}/usuarios/ofertas/createOffer.php`,
  getActiveOffers: `${API_BASE_URL}/usuarios/ofertas/getActiveOffers.php`,
  // POSTULACION
  createPostulation: `${API_BASE_URL}/usuarios/postulations/createPostulation.php`,
  getMyPostulations: `${API_BASE_URL}/usuarios/postulations/getMyPostulations.php`,
  addPostulation: `${API_BASE_URL}/usuarios/postulations/addPostulation.php`,
  GetPostulacion: `${API_BASE_URL}/usuarios/postulations/getPostulacion.php`,
  changeStatePostulation: `${API_BASE_URL}/usuarios/postulations/changeStatePostulation.php`,
  // EXAMEN OCUPACIONAL
  createExamOccupational: `${API_BASE_URL}/usuarios/occupational_exams/createExamOccupational.php`,
  getMyExamOccupational: `${API_BASE_URL}/usuarios/occupational_exams/getMyExamOccupational.php`,
  getOccupationalExam: `${API_BASE_URL}/usuarios/occupational_exams/getOccupationalExams.php`,
  updateOccupationalExamById: `${API_BASE_URL}/usuarios/occupational_exams/updateOccupationalExamById.php`,
  getExamsByUser: `${API_BASE_URL}/usuarios/occupational_exams/getExamsByUser.php`,
  // CURRICULUM
  getCurriculum:`${API_BASE_URL}/usuarios/curriculum/getCurriculum.php`,
  getCurriculumById: (id) =>`${API_BASE_URL}/usuarios/curriculum/getCurriculumById.php?id=${id}`,
  getMyCurriculum: () =>`${API_BASE_URL}/usuarios/curriculum/getMyCurriculum.php`,
  updateCurriculum: (id) => `${API_BASE_URL}/usuarios/curriculum/updateCurriculum.php?id=${id}`,
  getReferences: (id) => `${API_BASE_URL}/usuarios/curriculum/getReference.php?id=${id}`,
  createReference:`${API_BASE_URL}/usuarios/curriculum/createReference.php`,
  getEducation: (id) => `${API_BASE_URL}/usuarios/curriculum/getEducation.php?id=${id}`,
  createEducation:`${API_BASE_URL}/usuarios/curriculum/createEducation.php`,
  revisedEducation:(id) =>`${API_BASE_URL}/usuarios/curriculum/revisedEducation.php`,
  supportedEducation:(id) =>`${API_BASE_URL}/usuarios/curriculum/supportedEducation.php`,
  getDocsCurriculum: `${API_BASE_URL}/usuarios/curriculum/getDocsCurriculum.php`,
  createDocsCurriculum: `${API_BASE_URL}/usuarios/curriculum/createDocsCurriculum.php`,
  deleteDocCurriculum: `${API_BASE_URL}/usuarios/curriculum/deleteDocCurriculum.php`,

  getUniversities: `${API_BASE_URL}/usuarios/curriculum/getUniversities.php`,
  getDepartment: `${API_BASE_URL}/usuarios/curriculum/getDepartment.php`,
  getMunicipios: (departmentId) =>`${API_BASE_URL}/usuarios/curriculum/getMunicipios.php?departmentId=${departmentId}`,


  // ENTREVISTA
  getInterview:`${API_BASE_URL}/usuarios/interview/getInterview.php`,
  createInterview:`${API_BASE_URL}/usuarios/interview/createInterview.php`,
  // CONTRATOGH
  getContract: `${API_BASE_URL}/usuarios/contract_gh/getContract.php`,
  createContract: `${API_BASE_URL}/usuarios/contract_gh/createContract.php`,
  updateContract: `${API_BASE_URL}/usuarios/contract_gh/updateContract.php`,
  getDocuments: `${API_BASE_URL}/usuarios/contract_gh/getDocuments.php`,
  uploadDocument: `${API_BASE_URL}/usuarios/contract_gh/uploadDocument.php`,
  deleteDocument: `${API_BASE_URL}/usuarios/contract_gh/deleteDocument.php`,
  getCurriculumContract: `${API_BASE_URL}/usuarios/contract_gh/getCurriculumContract.php`,
  getContractByCurriculum: `${API_BASE_URL}/usuarios/contract_gh/getContractByCurriculum.php`,
  getreport: `${API_BASE_URL}/usuarios/contract_gh/getreport.php`,
  // OTRO SI
  getOtrosi: `${API_BASE_URL}/usuarios/contract_gh/otro_si/getOtrosi.php`,
  createOtrosi: `${API_BASE_URL}/usuarios/contract_gh/otro_si/createOtrosi.php`,

  // EXCEL SIN TOKEN
  report_excel : `${API_BASE_URL_DOCS}excel/report_excel.php`,
  report_plan_accion : `${API_BASE_URL_DOCS}excel/report_plan_accion.php`,
  // PDFs (SIN TOKEN)
  certificatePdf: `${API_BASE_URL_DOCS}pdf/fpdf/certificatePdf.php`,
  certificatePdfAll: `${API_BASE_URL_DOCS}pdf/fpdf/certificatePdfAll.php`,
  interviewPdf : `${API_BASE_URL_DOCS}pdf/fpdf/interviewPdf.php`,
  curriculumcertificate : `${API_BASE_URL_DOCS}pdf/fpdf/curriculumcertificate.php`,
  otrosiPdf : `${API_BASE_URL_DOCS}pdf/fpdf/otrosiPdf.php`,
  // MINUTAS DE CONTRATO PDF
  minutaObraLaborHS : `${API_BASE_URL_DOCS}pdf/fpdf/ObraLaborHogaresSustitutos.php`,
  minutaObraLaborEJC : `${API_BASE_URL_DOCS}pdf/fpdf/ObraLaborExternadoJornadaCompleta.php`,
  minutaObraLaborIns : `${API_BASE_URL_DOCS}pdf/fpdf/obralaborinstitucional.php`,
  minutaContratoFijoBC : `${API_BASE_URL_DOCS}pdf/fpdf/contratofijobuencomienzo.php`,

  // PLAN DE ACCIÓN
  create_programas: `${API_BASE_URL}/usuarios/plan_accion/create_programas.php`,
  create_plan: `${API_BASE_URL}/usuarios/plan_accion/create_plan_accion.php`,
  create_fase: `${API_BASE_URL}/usuarios/plan_accion/create_fase.php`,
  create_componente: `${API_BASE_URL}/usuarios/plan_accion/create_componente.php`,
  create_actividad: `${API_BASE_URL}/usuarios/plan_accion/create_actividad.php`,
  create_entregable: `${API_BASE_URL}/usuarios/plan_accion/create_entregable.php`,
  create_tiempo_ejecucion: `${API_BASE_URL}/usuarios/plan_accion/create_tiempo_ejecucion.php`,
  get_fases: `${API_BASE_URL}/usuarios/plan_accion/get_fases.php`,
  get_plan_activo: `${API_BASE_URL}/usuarios/plan_accion/get_plan_activo.php`,
  get_plan: `${API_BASE_URL}/usuarios/plan_accion/get_plan.php`,
  get_componentes: `${API_BASE_URL}/usuarios/plan_accion/get_componentes.php`,
  get_programas: `${API_BASE_URL}/usuarios/plan_accion/get_programas.php`,
  get_actividades: `${API_BASE_URL}/usuarios/plan_accion/get_actividades.php`,
  get_entregables: `${API_BASE_URL}/usuarios/plan_accion/get_entregables.php`,
  get_tiempo_ejecucion: `${API_BASE_URL}/usuarios/plan_accion/get_tiempo_ejecucion.php`,


  // AREA DE PROYECTOS
  // Entidad
  createEntity: `${API_BASE_URL}/usuarios/mod_proyectos/entity/createEntity.php`,
  getEntity: `${API_BASE_URL}/usuarios/mod_proyectos/entity/getEntity.php`,
  changeStateEntity: `${API_BASE_URL}/usuarios/mod_proyectos/entity/changeStateEntity.php`,
  // Propuesta
  getEntityActive: `${API_BASE_URL}/usuarios/mod_proyectos/proposal/getEntityActive.php`,
  createProposal: `${API_BASE_URL}/usuarios/mod_proyectos/proposal/createProposal.php`,
  getProposal: `${API_BASE_URL}/usuarios/mod_proyectos/proposal/getProposal.php`,
  updateProposal: `${API_BASE_URL}/usuarios/mod_proyectos/proposal/updateProposal.php`,
  getDepartmentCol: `${API_BASE_URL}/usuarios/mod_proyectos/proposal/getDeparmentCol.php`,
  getProposalById: `${API_BASE_URL}/usuarios/mod_proyectos/proposal/getProposalById.php`,
  // Contrato proyectos
  createContratoProyectos: `${API_BASE_URL}/usuarios/mod_proyectos/contrato_proyectos/createContrato.php`,
  getContratoProyecto: `${API_BASE_URL}/usuarios/mod_proyectos/contrato_proyectos/getContrato.php`,
  updateContratoProyectos: `${API_BASE_URL}/usuarios/mod_proyectos/contrato_proyectos/updateContrato.php`,
 


};
